/**
 *
 * @page 用户中心/我的方案/项目管理
 *
 **/

import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import BaseModal from '&/components/BaseModal';
import {
    Select,
    Space,
    Button,
    Empty,
    Spin,
    Modal,
    message,
    Input,
    Pagination,
    Row,
    Col,
    Form,
} from 'antd';
import { useRouterTarget } from '&/utils/customHooks';
import ProjectCard from '@/components/UserCenter1.4/ProjectCard';
import BuyService from '@/components/UserCenter1.4/BuyService';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
    queryProductList,
    removeProject,
    renameProject,
    exitProject,
} from '@/api/personCenter/projectSpace1.4';
import { useRef } from 'react';
import OperationGuidance from '&/components/ProjectSpace/OperationGuidance';
import { getSMSVerificationCode } from '&/api/Dialogs/signUpDlg';
import { observer, inject } from 'mobx-react';
import { formatPhone } from '&/utils/common';
import './ProjectSpace.scss';
const { Option } = Select;

function ProjectSpace(props) {
    const { appStore } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState({
        list: [],
        nums: { count_num: 0, expire_num: 0 },
        total: 0,
        gratisProjectNum: '5',
    });

    const [queryForm, setQueryForm] = useState({
        tab: 0,
        sort: 1,
        page: 1,
        pageNum: 12,
    });

    const handlePageChange = (page, pageNum) => {
        setQueryForm(prev => ({ ...prev, page, pageNum }));
    };

    useEffect(() => {
        getList();
    }, [queryForm]);

    const onSelected = sort => {
        setQueryForm(prev => ({ ...prev, sort }));
    };

    function getList() {
        setIsLoading(true);
        queryProductList(queryForm)
            .then(({ data }) => {
                setResult({
                    list: data.list,
                    nums: data.nums,
                    total: data.page.totalList - 0,
                    gratisProjectNum: data.gratisProjectNum,
                });
            })
            .catch(() => {
                setResult({
                    list: [],
                    nums: { count_num: 0, expire_num: 0 },
                    total: 0,
                    gratisProjectNum: '5',
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const TABS = [
        {
            name: intl.get('userCenter.allProject'),
        },
        {
            name: intl.get('userCenter.createdProject'),
        },
        {
            name: intl.get('userCenter.participantProject'),
        },
    ];

    const onTabChange = (e, i) => {
        if (i === queryForm.tab) return;
        setQueryForm(prev => ({ ...prev, tab: i, page: 1 }));
    };

    const targetPage = useRouterTarget();

    const targetDetail = ({ id, div, status }) => {
        const PATHS = ['project-detail', 'scheme-detail'];
        targetPage({
            pathname: `/user-center/project-space/${PATHS[div - 1]}`,
            search: {
                id,
            },
            state: {
                projectStatus: status,
            },
        });
    };

    const [visible, setVisible] = useState(false);
    const [formData, setFormData] = useState({});

    const initType = useRef();

    function toPay(info) {
        projectType.current = info.div;
        setFormData(info);
        initType.current = 'unpaid';
        setVisible(true);
    }

    const projectType = useRef(1);
    const createProject = (type = 1) => {
        setFormData({});
        initType.current = 'form';
        projectType.current = type;
        setVisible(true);
    };

    const btnGroup = (size = 'middle') => (
        <Space className="btns">
            {/*<Button type="primary" onClick={() => createProject()} size={size}>
                {intl.get('projectSpace.createDesign')}
            </Button>*/}
            <Button type="primary" size={size} onClick={() => createProject(2)}>
                {intl.get('projectSpace.synergyDesign')}
            </Button>
        </Space>
    );

    const [delVisible, setDelVisible] = useState(false);
    const [delLoading, setdelLoading] = useState(false);
    const [delDisabled, setdelDisabled] = useState(false);
    const [isClicked, setisClicked] = useState(false); // 是否已经点击发送
    const [count, setcount] = useState(60); // 多少秒后可以再次发送
    const { mobile } = appStore.userInfo;
    const [code, setCode] = useState();

    useEffect(() => {
        setdelDisabled(!(code?.length === 6));
    }, [code]);

    const onDelCancel = () => {
        formRef.resetFields();
        setCode('');
        setDelVisible(false);
    };

    // 发送验证码
    const sendCode = async () => {
        await getSMSVerificationCode({
            mobile,
            type: 'PROJECT',
        });
        setisClicked(true);
        let time = count;
        const timmer = setInterval(() => {
            time--;
            setcount(time);
            if (time !== 0) return;
            clearInterval(timmer);
            setcount(60);
            setisClicked(false);
        }, 1e3);
    };

    const currentDel = useRef();
    const openRemoveModal = item => {
        currentDel.current = item;
        setDelVisible(true);
    };

    async function onRemove() {
        if (!/^\d{6}$/.test(code)) {
            message.warning(intl.get('userCenter.codeError'));
            return;
        }
        setdelLoading(true);
        const isNeedResetParam = queryForm.page > 1 && result.list.length < 2;
        try {
            const { msg } = await removeProject({
                projectId: currentDel.current.id,
                code,
                mobile,
            });
            onDelCancel();
            message.success(msg);
            isNeedResetParam
                ? setQueryForm(prev => ({ ...prev, page: --prev.page }))
                : getList();
        } finally {
            setdelLoading(false);
        }
    }

    function onExit(item) {
        const isNeedResetParam = queryForm.page > 1 && result.list.length < 2;
        const modal = Modal.confirm({
            title: intl.get('base.warning'),
            icon: <ExclamationCircleOutlined />,
            content: intl.get('projectSpace.extitProjetWarn', {
                name: item.name,
            }),
            okText: intl.get('base.confirm'),
            cancelText: intl.get('base.cancel'),
            okButtonProps: { loading: false },
            centered: true,
            onOk: async () => {
                modal.update({ okButtonProps: { loading: true } });
                try {
                    const { msg } = await exitProject({
                        projectId: item.id,
                    });
                    message.success(msg);
                    isNeedResetParam
                        ? setQueryForm(prev => ({ ...prev, page: --prev.page }))
                        : getList();
                } finally {
                    modal.update({ okButtonProps: { loading: false } });
                }
            },
        });
    }

    const [renameVisible, setRenameVisible] = useState(false);
    const [formRef] = Form.useForm();

    function onRename(item) {
        formRef.setFieldsValue({
            projectId: item.id,
            name: item.name,
        });
        setRenameVisible(true);
    }

    const onCancel = () => {
        formRef.resetFields();
        setRenameVisible(false);
    };

    const [okLoading, setOkLoading] = useState(false);

    function onSubmitName(values) {
        setOkLoading(true);
        renameProject({
            ...values,
        })
            .then(({ msg }) => {
                message.success(msg);
                const idx = result.list.findIndex(
                    e => e.id === values.projectId
                );
                setResult(prev => {
                    const next = { ...prev };
                    next.list[idx].name = values.name;
                    return next;
                });
                setRenameVisible(false);
            })
            .finally(() => {
                setOkLoading(false);
            });
    }

    const queryUserStatus = async () => {
        try {
            const res = await queryProductList({
                tab: 0,
                sort: 1,
                page: 1,
                pageNum: 1,
            });
            const { guidance } = res.data;
            if (guidance === 0 || guidance === 1) {
                showOperationGuidanceModal();
            }
        } catch (e) {}
    };
    const OperationGuidanceRef = useRef(null);
    const showOperationGuidanceModal = () => {
        OperationGuidanceRef.current.show();
    };
    useEffect(() => {
        queryUserStatus();
    }, []);

    return (
        <>
            <BasePageWrap
                className="project-space"
                type="card"
                tabs={TABS}
                headerRight={
                    <div className="header-right">
                        <div>
                            {intl.get('projectSpace.inTotal')}
                            <span className="number-span">
                                {result.nums.count_num}
                            </span>
                            {intl.get('projectSpace.projectTotal', {
                                total: '',
                            })}
                            <span className="number-span">
                                {result.nums.expire_num}
                            </span>
                            {intl.get('projectSpace.aboutToexpire', {
                                expire: '',
                            })}
                        </div>
                        {btnGroup()}
                    </div>
                }
                onTabChange={onTabChange}>
                <Spin spinning={isLoading}>
                    <Select
                        className="sort-select"
                        defaultValue={1}
                        onChange={onSelected}
                        bordered={false}>
                        <Option value={1}>
                            {intl.get('projectSpace.sortByCreate')}
                        </Option>
                        <Option value={2}>
                            {intl.get('projectSpace.sortByUpdate')}
                        </Option>
                    </Select>

                    {!result.total ? (
                        <Empty
                            image={
                                require('&/assets/img/userCenter/emptyydata-object.png')
                                    .default
                            }
                            imageStyle={{
                                height: 160,
                                marginTop: '10%',
                            }}
                            description={
                                <>
                                    <div className="hint-message">
                                        {queryForm.tab === 2
                                            ? intl.get('base.projectListEmpty')
                                            : intl.get(
                                                  'projectSpace.noProject'
                                              )}
                                    </div>
                                </>
                            }>
                            {queryForm.tab < 2 && btnGroup('large')}
                        </Empty>
                    ) : (
                        <>
                            <Row gutter={[24, 24]}>
                                {result.list.map(e => (
                                    <Col
                                        xs={8}
                                        sm={8}
                                        md={8}
                                        lg={8}
                                        xl={6}
                                        key={e.id}>
                                        <ProjectCard
                                            source={e}
                                            remove={openRemoveModal}
                                            rename={onRename}
                                            onExit={onExit}
                                            clickName={() => targetDetail(e)}
                                            toPay={toPay}
                                        />
                                    </Col>
                                ))}
                            </Row>
                            <Pagination
                                size="small"
                                current={queryForm.page}
                                onChange={handlePageChange}
                                total={result.total}
                                pageSize={queryForm.pageNum}
                                showTotal={total =>
                                    intl.get('base.total', { total })
                                }
                            />
                        </>
                    )}
                </Spin>
            </BasePageWrap>
            {visible && (
                <BuyService
                    visible={visible}
                    initData={formData}
                    div={projectType.current}
                    initState={initType.current}
                    setVisible={setVisible}
                    gratisProjectNum={result.gratisProjectNum}
                    refesh={getList}></BuyService>
            )}
            <OperationGuidance ref={OperationGuidanceRef} queryList={getList} />
            <BaseModal
                title={intl.get('base.rename')}
                visible={renameVisible}
                onOk={formRef.submit}
                width="20rem"
                forceRender
                okButtonProps={{
                    loading: okLoading,
                }}
                onCancel={onCancel}>
                <Form form={formRef} onFinish={onSubmitName}>
                    <Form.Item
                        name="name"
                        validateFirst
                        rules={[
                            {
                                required: true,
                                message: intl.get(
                                    'projectSpace.inputProjectName'
                                ),
                            },
                            {
                                validator: async (rule, value) => {
                                    if (!value) return;
                                    const val = value.replace(
                                        /[\u4e00-\u9fa5]/g,
                                        'aa'
                                    );
                                    if (val.length < 31) {
                                        return Promise.resolve();
                                    }
                                    throw new Error(
                                        intl.get('projectSpace.limit30')
                                    );
                                },
                            },
                        ]}>
                        <Input allowClear></Input>
                    </Form.Item>
                    <Form.Item name="projectId" hidden>
                        <Input></Input>
                    </Form.Item>
                </Form>
            </BaseModal>

            <BaseModal
                title={intl.get('projectSpace.disbanded')}
                okText={intl.get('projectSpace.confirmDisbanded')}
                visible={delVisible}
                onCancel={onDelCancel}
                forceRender
                onOk={onRemove}
                okButtonProps={{
                    loading: delLoading,
                    disabled: delDisabled,
                    ghost: delDisabled,
                }}>
                <div className="form-group warn-block">
                    <img
                        src={
                            require('&/assets/img/userCenter/warnimg.png')
                                .default
                        }
                        className="warn-image"
                    />
                    <div className="warn-block__msg">
                        {intl.get('projectSpace.disbandedWarn')}
                    </div>
                    <div className="warn-block__status">
                        该项目
                        {+currentDel.current?.status === 4
                            ? '已到期'
                            : '还未到期'}
                    </div>
                </div>
                <div className="form-group send-msg-block">
                    <div className="current-phone">
                        {intl.get('projectSpace.currentPhone', {
                            mobile: formatPhone(mobile),
                        })}
                    </div>
                    <div className="send-msg-group">
                        <Input
                            value={code}
                            onChange={e => setCode(e.target.value)}
                            maxLength={6}
                            placeholder={intl.get('userCenter.inputCodeWarn')}
                        />
                        <Button
                            disabled={isClicked}
                            type="text"
                            onClick={sendCode}
                            className="auth-code-btn">
                            {isClicked
                                ? intl.get('signUpSignIn.interval', {
                                      count,
                                  })
                                : intl.get('userCenter.getCode')}
                        </Button>
                    </div>
                </div>
            </BaseModal>
        </>
    );
}

export default inject('appStore')(observer(ProjectSpace));
